import type {DepartmentHealthFreshnessBandKey} from '../../types/DepartmentHealthTypes';

export const DEPARTMENT_HEALTH_FRESHNESS_DISPLAY_BANDS: {
  key: DepartmentHealthFreshnessBandKey;
  labelKey: string;
  countKey: 'freshCount' | 'ageingCount' | 'staleCount' | 'veryStaleCount';
  pctKey: 'freshPct' | 'ageingPct' | 'staleBandPct' | 'veryStalePct';
}[] = [
  {key: 'fresh', labelKey: 'bands.fresh', countKey: 'freshCount', pctKey: 'freshPct'},
  {key: 'ageing', labelKey: 'bands.ageing', countKey: 'ageingCount', pctKey: 'ageingPct'},
  {key: 'stale', labelKey: 'bands.stale', countKey: 'staleCount', pctKey: 'staleBandPct'},
  {key: 'veryStale', labelKey: 'bands.veryStale', countKey: 'veryStaleCount', pctKey: 'veryStalePct'},
];
